module.exports = __webpack_public_path__ + "static/media/banner_420x230_5.e759cc6d.jpg";